import React from 'react';

const CheckChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M5.5 12.2L9.4 16l9.1-9"
            fill="none"
            stroke="#050505"
            strokeWidth={2}
            strokeMiterlimit={10}
        />
    </svg>
);

CheckChunkySvg.displayName = 'CheckChunkySvg';
export default CheckChunkySvg;
